import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';

@Injectable()
export class TaskCancelTaskFilesReviewService {
  constructor(private client: HttpClient, private configService: ConfigService) {}

  public cancel(taskId: string, fileType: string): Observable<any> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/cancel-files-review`;
    let params: HttpParams = new HttpParams().set('type', fileType);

    return this.client.post(url, params).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
